<template>
  <v-container fluid>
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-tabs v-model="tabs" center-active fixed-tabs>
          <v-tab>운전이력</v-tab>
          <v-tab>고장이력</v-tab>
        </v-tabs>
      </v-col>
      <v-col class="pb-0" cols="12">
        <v-select outlined solo dense hide-details :items="comboList2" v-model="select2"></v-select>
      </v-col>
      <v-col cols="12">
        <v-select outlined solo dense hide-details :items="comboList" v-model="select"></v-select>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col class="pt-0">
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-row no-gutters>
              <v-col cols="12" class="d-inline-flex justify-end align-center">
                <date-picker :date="startDate"></date-picker>
              </v-col>
              <v-col cols="12">
                <date-picker :date="endDate"></date-picker>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn outlined class="default-btn mx-5" small @click="retrieveGrid">조회</v-btn>
                <v-btn outlined class="mr-5 excel_down" small @click="excelDown">엑셀다운로드</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <real-grid
                  ref="dataGrid"
                  class="mt-1 mb-5 w-full"
                  :options="grid.gridOption"
                  :fields="grid.gridFields"
                  :columns="grid.gridColumns"
                  :height="grid.height"
                  :retrieve-api="gridRetrieveApi"
                ></real-grid>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row no-gutters>
              <v-col cols="12" class="d-inline-flex justify-end align-center">
                <date-picker :date="startDate"></date-picker>
              </v-col>
              <v-col cols="12">
                <date-picker :date="endDate"></date-picker>
              </v-col>
              <v-col class="d-flex justify-end" cols="12">
                <v-btn outlined class="default-btn mx-5" small @click="retrieveGrid2">조회</v-btn>
                <v-btn outlined class="mr-5 excel_down" small @click="excelDown2">엑셀다운로드</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <real-grid
                  ref="dataGrid2"
                  class="mt-1 mb-5 w-full"
                  :options="grid.gridOption"
                  :fields="grid.gridFields"
                  :columns="grid.gridColumns"
                  :height="grid.height"
                  :retrieve-api="gridRetrieveApi"
                ></real-grid>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getWorkRecord } from '@/api/ess/siteWork'
import day from 'dayjs'
import DatePicker from '@/components/monitoring/DatePicker'
import RealGrid from '@/components/grid/Realgrid'
import Message from '@/utils/message'

export default {
  components: {
    DatePicker,
    RealGrid
  },
  props: {
    site_id: { type: String, default: '' },
    essData: { type: [Object, Object], default: undefined }
  },
  data() {
    return {
      tabs: 0,
      date: '',
      date2: '',
      comboList2: [
        {
          text: '태양광 인버터',
          value: 'PVPCS'
        },
        {
          text: 'ESS PCS',
          value: 'EPCS'
        },
        {
          text: '배터리',
          value: 'BSC'
        }
      ],
      select: '',
      select2: 'PVPCS',
      startDate: day(Date.now())
        .subtract(31, 'day')
        .format('YYYY-MM-DD'),
      endDate: day(Date.now()).format('YYYY-MM-DD'),
      essResult: [],
      PVPCS: [],
      EPCS: [],
      BSC: [],
      isPvpcsSelected: true,
      isEpcsSelected: false,
      isBscSelected: false,
      epcsPcodeid: '',
      pvpcsPcodeid: '',
      bscPcodeid: '',
      workRecordResult: [
        {
          date: '2021-04-10',
          run_status: '정지',
          subcomp: 'PVPCS01',
          time: '00:00:00'
        }
      ],
      grid: {
        height: 442.5,
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridFields: [
          { fieldName: 'date', dataType: 'string' },
          { fieldName: 'time', dataType: 'string' },
          { fieldName: 'subcomp', dataType: 'string' },
          { fieldName: 'run_status', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'date',
            fieldName: 'date',
            header: {
              text: '일자'
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            // editable 옵션이 false 일 경우, 수정할 수 없다.
            editable: false
          },
          {
            name: 'time',
            fieldName: 'time',
            header: {
              text: '시간'
            },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'subcomp',
            fieldName: 'subcomp',
            header: {
              text: '인버터 번호'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'run_status',
            fieldName: 'run_status',
            header: {
              text: '이력'
            },
            renderer: {
              type: 'icon',
              iconCallback: function(grid, cell) {
                let image =
                  cell.value === '운전' || cell.value === '대기'
                    ? 'green'
                    : 'red'
                return `/external/runImage/running_${image}.png`
              },
              iconHeight: 15,
              iconWidth: 15
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          }
        ]
      }
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.dataGrid.retrieve()
    })
  },
  computed: {
    gridRetrieveApi() {
      return this.retrieveApi
    },
    comboList() {
      let type =
        this.select2 === 'PVPCS'
          ? 'PVPCS'
          : this.select2 === 'EPCS'
            ? 'EPCS'
            : 'BSC'
      let all = {
        PVPCS: {
          text: '태양광 인버터 전체',
          value: 'PVPCS'
        },
        EPCS: {
          text: 'ESS PCS 전체',
          value: 'PVPCS'
        },
        BSC: {
          text: '배터리 전체',
          value: 'BSC'
        }
      }
      let list = []
      list.push(all[type])
      for (let item of this.essResult) {
        if (item.photo === type) {
          list.push({
            text: item.description,
            value: item.codeid
          })
        }
      }
      return list
    },
    pCodeId() {
      let type =
        this.select2 === 'PVPCS'
          ? 'PVPCS'
          : this.select2 === 'EPCS'
            ? 'EPCS'
            : 'BSC'
      let allCheck =
        this.select === 'PVPCS' ||
        this.select === 'EPCS' ||
        this.select === 'BSC'
      let id = ''
      if (allCheck) {
        for (let item of this.essResult) {
          if (item.photo === type) {
            id = item.pcodeid
            break
          }
        }
      }
      return id
    }
  },
  watch: {
    comboList() {
      this.select = this.comboList[0].value
    }
  },
  methods: {
    retrieveGrid() {
      this.$refs.dataGrid.getDataProvider().clearRows()
      this.$refs.dataGrid.retrieve()
    },
    retrieveGrid2() {
      this.$refs.dataGrid2.getDataProvider().clearRows()
      this.$refs.dataGrid2.retrieve()
    },
    retrieveApi() {
      console.log('retrieveApi', this.pCodeId)
      console.log('retrieveApi', this.select)
      return new Promise((resolve, reject) => {
        let params = {
          code_id: this.pCodeId || this.select,
          startDate: this.startDate,
          endDate: this.endDate
        }
        getWorkRecord(params).then(res => {
          resolve(res)
        })
      })
    },
    initData() {
      if (this.essData.result !== 'noData') {
        this.essResult = this.essData.essResult
      }
    },
    changeComponent(e) {
      let component = e.target.value

      this.isPvpcsSelected = false
      this.isEpcsSelected = false
      this.isBscSelected = false

      if (component === 'EPCS') {
        this.isEpcsSelected = true
      } else if (component === 'BSC') {
        this.isBscSelected = true
      } else {
        this.isPvpcsSelected = true
      }
    },
    excelDown() {
      // 엑셀다운로드
      let gridView = this.$refs.dataGrid.getGridView()
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: '운전/정지이력_' + day().format('YYYY-MM-DD') + '.xlsx',
        indicator: 'visible',
        footer: 'hidden',
        header: 'visible',
        allColumns: true,
        done: function() {
          Message.success('출력이 완료되었습니다.')
        }
      })
    },
    excelDown2() {
      // 엑셀다운로드
      let gridView = this.$refs.dataGrid2.getGridView()
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: '운전/정지이력_' + day().format('YYYY-MM-DD') + '.xlsx',
        indicator: 'visible',
        footer: 'hidden',
        header: 'visible',
        allColumns: true,
        done: function() {
          Message.success('출력이 완료되었습니다.')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#realgrid {
  height: 442.5px;
}

.excel_down {
  width: 100px;
  height: 30px;
  border: 1px solid #24943e;
  color: #24943e;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
}

.workSearchBtn {
  width: 55px;
  height: 28px;
  float: left;
  background-color: #2976d2;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  padding-top: 4px;
}
</style>
